import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { HandlingUnitEndpoint } from '../../constants/handling-unit-endpoint';
import { HandlingUnitOverview } from '../../models';
import { Tracking } from '../../../../models/monitoring-tracking';

@Injectable({
  providedIn: 'root',
})
export class HandlingUnitOverviewService {
  constructor(private http: WrapperHttpService) {}

  getOverviewData({
    deliveryNoteNumber,
    handlingUnitNumber,
  }: {
    deliveryNoteNumber: string;
    handlingUnitNumber: string;
  }): Observable<HandlingUnitOverview> {
    return this.http
      .withLoading()
      .get<HandlingUnitOverview>(
        `${API_URL}${HandlingUnitEndpoint.Base}${HandlingUnitEndpoint.Monitoring}${HandlingUnitEndpoint.DeliveryNote}/${deliveryNoteNumber}${HandlingUnitEndpoint.HandlingUnit}/${handlingUnitNumber}${HandlingUnitEndpoint.Overview}`,
      );
  }

  getTracking({
    deliveryNoteNumber,
    handlingUnitNumber,
  }: {
    deliveryNoteNumber: string;
    handlingUnitNumber: string;
  }): Observable<Tracking[]> {
    return this.http
      .withLoading()
      .get<Tracking[]>(
        `${API_URL}${HandlingUnitEndpoint.Base}${HandlingUnitEndpoint.Monitoring}${HandlingUnitEndpoint.DeliveryNote}/${deliveryNoteNumber}${HandlingUnitEndpoint.HandlingUnit}/${handlingUnitNumber}${HandlingUnitEndpoint.Statuses}`,
      );
  }
}
